// src/hooks/access/useDataSharingAccess.ts

import useEnvironment from '../location/useEnviroment'
import useUserWithRole from '../authentication/useUserWithRole'
import { isDemoTenant } from '../../utils/helpers'

export default function useDataSharingAccess() {
  const {
    data: environment,
    isLoading: environmentLoading
  } = useEnvironment()

  const {
    role,
    isLoading: roleLoading
  } = useUserWithRole()

  return {
    canAccess:
      role === 'member' &&
      isDemoTenant(environment?.tenant || ''),
    isLoading:
      environmentLoading ||
      roleLoading
  }
}